export default __webpack_public_path__ + "static/carrick-85d82c19930d3cbe859aacd7aa4e09c8.jpg";